import FullStory from '@/fullstory';

export function fullstoryPlugin() {
    return {
        $FullStory: FullStory
    }
}